<!-- Overlay Navigation Menu -->

<div class="overlay">
    <nav class="overlay-menu">
        <div class="close-icon close-menu" (click)="menuItemClicked()">
            <span class="menu-line"></span>
            <span class="menu-line"></span>
        </div>
        <ul>
<!--            <a class="overlay-link&#45;&#45;first" (click)="showPage('/aktuelle-konkurrencer')">-->
<!--                <li class="close-menu">Konkurrencer</li>-->
<!--            </a>-->
            <a class="overlay-link--first" (click)="showPage('/glade-vindere')">
                <li class="close-menu">Vinderhistorier</li>
            </a>
            <a class="overlay-link--first" (click)="showPage('/har-jeg-vundet')" >
                <li class="close-menu">Har jeg vundet?</li>
            </a>
            <a class="overlay-link--first" (click)="showPage('/om-klasselotteriet')" >
                <li class="close-menu">Om Klasselotteriet</li>
            </a>
            <a class="overlay-link--first" (click)="navigateToMyPage()" (click)="menuItemClicked()">
                <li class="close-menu">Min side</li>
            </a>
        </ul>
    </nav>
    <hr />
    <div class="menu-small mb-4">
        <ul>
            <a href='/om-klasselotteriet/spil-hos-forhandlere'>
                <li class="close-menu">Spil hos forhandlere</li>
            </a>
            <a (click)="showPage('/support')">
                <li class="close-menu">Spørgsmål & kontakt</li>
            </a>
            <a (click)="showPage('/om-klasselotteriet/jobs')" >
                <li class="close-menu">Job i Klasselotteriet</li>
            </a>
            <ng-container *ngIf="isAuthorized === true">
                <li class="logout close-menu" (click)="onSignOutClick()">
                    Log ud
                </li>
            </ng-container>
        </ul>
    </div>
</div>
<div class="overlay-back close-menu" (click)="menuItemClicked()"></div>
<!-- END Overlay Navigation Menu -->
